<app-stackable-notifications-manager class="tw-fixed tw-right-[32px] tw-bottom-[32px] tw-z-50"></app-stackable-notifications-manager>
<div class="app-content">
  <div *ngIf="lenderUser$ | async">
    <app-alert *ngIf="siteIsUpdated" class="site-updated-alert" level="info" message="Updates for Pipeline available! Please hard refresh at your earliest convenience. Windows: Shift+Ctrl+R. Mac: Shift+Command+R."></app-alert>
    <app-alert *ngIf="!isSupported" class="unsupported-browser-alert" level="warning" message="You are not using a supported device or browser and may have a less than optimal experience. For a supported experience, please use the most recent version of Chrome on a desktop computer."></app-alert>
    <app-global-header
      [user]="lenderUser$ | async"
      (globalHeaderLoaded)="headerLoaded()"
      (cxDrawerToggle)="globalCxSideNav.toggle()"
      (notificationDrawerToggle)="globalNotificationSideNav.toggle()"
    ></app-global-header>
    <app-callbar></app-callbar>
    <app-notifications-smart [user]="lenderUser$ | async"></app-notifications-smart>
    <app-claim-lead-bar-smart [user]="lenderUser$ | async"></app-claim-lead-bar-smart>
    <app-global-borrower-tabs-smart></app-global-borrower-tabs-smart>
  </div>
  <mat-drawer-container>
    <mat-drawer-content>
      <div>
        <div *ngIf="globalHeaderLoaded || loginPage; else loading">
          <router-outlet></router-outlet>
        </div>
        <ng-template #loading>
          <app-loading></app-loading>
        </ng-template>
      </div>
    </mat-drawer-content>
    <mat-drawer #globalNotificationSideNav mode="over" position="end" opened="false" hasBackdrop="true" class="tw-w-1/4">
      <app-notifications-history-smart
        class="tw-flex"
        (notificationDrawerClose)="globalNotificationSideNav.close()"
      ></app-notifications-history-smart>
    </mat-drawer>
    <mat-drawer #globalCxSideNav mode="side" position="start" opened="false" hasBackdrop="false" class="!tw-w-1/4">
      <app-cx-interaction-smart
        *ngIf="canViewCxInteractions"
        [user]="lenderUser$ | async"
        class="tw-flex tw-justify-center"
        (cxDrawerClose)="globalCxSideNav.close()"
      ></app-cx-interaction-smart>
    </mat-drawer>
  </mat-drawer-container>
</div>
